import { Dialog, DialogBody, DialogFooter, DialogHeader, Button, Card, CardBody } from '@material-tailwind/react';
import React, { useEffect, useState } from 'react';

export default function RoomConvert({ isOpen, onClose, onSubmit, roomConvertRequest }) {

    const [newRoomType, setNewRoomType] = useState("");
    const [newPaymentDetails, setNewPaymentDetails] = useState([]);
    const [unitDiscount, setUnitDiscount] = useState(0);

    useEffect(() => {
        let priceDetails = [];
        if (newRoomType) {
            const rc = getRoomDetailsByCategory(newRoomType);
            const currentRoom = getPreviousRoom(roomConvertRequest.currentRoomNo);
            let newCheckDate = currentRoom.checkInDateTime;
            if (currentRoom.totalDays > 1) {
                newCheckDate = subtractOneDay(currentRoom.checkOutDateTime);
            }
            const priceDetail = {};
            priceDetail.roomNo = roomConvertRequest.currentRoomNo;
            priceDetail.category = rc.category;
            priceDetail.effectiveCheckInDate = newCheckDate;
            priceDetail.fare = 1 * rc.price;
            priceDetail.extraBedCost = 1 * currentRoom.extraBeds * rc.extraBedCharges;
            priceDetail.gst = ((1 * rc.price) + priceDetail.extraBedCost) * (rc.gst / 100);
            priceDetail.totalCost = priceDetail.fare + priceDetail.extraBedCost + priceDetail.gst;
            priceDetail.discount = 1 * unitDiscount;
            priceDetails.push(priceDetail);
        }
        setNewPaymentDetails(priceDetails);

    }, [newRoomType, unitDiscount]);

    function subtractOneDay(dateStr) {
        const [datePart, timePart] = dateStr.split(" ");
        const [day, month, year] = datePart.split("-").map(Number);

        let date = new Date(year, month - 1, day);

        date.setDate(date.getDate() - 1);

        const newDateStr = `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()} ${timePart}`;

        return newDateStr;
    }

    function getRoomDetailsByCategory(category) {
        const rc = roomConvertRequest.roomTypes.find(rc => rc.category === category);
        return rc;
    }

    function getPreviousRoom(roomNo) {
        return roomConvertRequest.card.roomDetails.find(rd => rd.roomNo === roomNo && !rd.closed);
    }

    function getPreviousCheckIn(roomNo) {
        return roomConvertRequest.checkIns.find(ck => ck.roomNo === roomNo);
    }

    const handleSubmitInternal = async () => {
        if (newRoomType) {
            const partialCheckouts = [];
            const newCheckIns = [];
            const newRoomDetails = [];
            roomConvertRequest.card.roomDetails.forEach(previousRoomDetail => {
                if (previousRoomDetail.roomNo === roomConvertRequest.currentRoomNo && !previousRoomDetail.closed) {
                    if (previousRoomDetail.totalDays > 1) {

                        const previousCheckIn = getPreviousCheckIn(roomConvertRequest.currentRoomNo);
                        const newCheckIn = JSON.parse(JSON.stringify(previousCheckIn));
                        previousCheckIn.checkOutDateTime = subtractOneDay(previousCheckIn.checkOutDateTime);
                        previousCheckIn.checkOutEpoch = previousCheckIn.checkOutEpoch - 86400000;
                        newCheckIn.category = newRoomType;

                        partialCheckouts.push(previousCheckIn);
                        newCheckIns.push(newCheckIn);

                        const newRoomDetail = JSON.parse(JSON.stringify(previousRoomDetail));
                        previousRoomDetail.checkOutDateTime = subtractOneDay(previousRoomDetail.checkOutDateTime);
                        previousRoomDetail.totalDays = previousRoomDetail.totalDays - 1
                        previousRoomDetail.closed = true;
                        newRoomDetail.checkInDateTime = previousRoomDetail.checkOutDateTime;
                        newRoomDetail.converted = true;
                        newRoomDetail.unitDiscount = unitDiscount;
                        newRoomDetail.category = newRoomType;
                        newRoomDetail.totalDays = 1;
                        newRoomDetail.unitFare = 0;
                        newRoomDetails.push(newRoomDetail);

                    } else {
                        previousRoomDetail.category = newRoomType;
                        previousRoomDetail.unitDiscount = unitDiscount;
                        previousRoomDetail.unitFare = 0;
                        const previousCheckIn = getPreviousCheckIn(roomConvertRequest.currentRoomNo);
                        const newCheckIn = JSON.parse(JSON.stringify(previousCheckIn));
                        newCheckIn.category = newRoomType;
                        newCheckIns.push(newCheckIn);
                    }
                }
            });
            roomConvertRequest.checkIns = newCheckIns;
            roomConvertRequest.card.roomDetails = [...roomConvertRequest.card.roomDetails, ...newRoomDetails];
            let totalAmount = 0;
            let totalDiscountTemp = 0;
            roomConvertRequest.card.roomDetails.forEach(function (roomDetail) {
                const rc = getRoomDetailsByCategory(roomDetail.category);
                if (!roomDetail.unitFare) {
                    roomDetail.unitFare = rc.price;
                }
                let differenceDays = getDateDifference(roomDetail.checkInDateTime, roomDetail.checkOutDateTime, 0);
                roomDetail.totalDays = differenceDays;
                roomDetail.fare = differenceDays * (roomDetail.unitFare || rc.price);
                totalDiscountTemp += differenceDays * roomDetail.unitDiscount || 0;
                roomDetail.extraBedCost = differenceDays * roomDetail.extraBeds * rc.extraBedCharges;
                roomDetail.gst = ((differenceDays * (roomDetail.unitFare || rc.price)) + roomDetail.extraBedCost) * (rc.gst / 100);
                roomDetail.totalAmount = roomDetail.fare + roomDetail.gst + roomDetail.extraBedCost;
                totalAmount += roomDetail.totalAmount;
            });
            roomConvertRequest.card.totalAmount = totalAmount - totalDiscountTemp;
            roomConvertRequest.card.amountDue = roomConvertRequest.card.totalAmount - roomConvertRequest.card.amountReceived - roomConvertRequest.card.discount;

            await onSubmit(roomConvertRequest.card, roomConvertRequest.checkIns, partialCheckouts);
        }
    };

    function getDateDifference(dateString1, dateString2, gracePeriod = 0) {
        const [day1, month1, year1, hour1, minute1] = dateString1.split(/[\s:-]/);
        const [day2, month2, year2, hour2, minute2] = dateString2.split(/[\s:-]/);

        const date1 = new Date(year1, month1 - 1, day1, hour1 || 0, minute1 || 0);
        const date2 = new Date(year2, month2 - 1, day2, hour2 || 0, minute2 || 0);

        date2.setHours(date2.getHours() - gracePeriod);

        const differenceMs = Math.abs(date2 - date1);

        const differenceDays = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));

        if (differenceDays === 0) {
            return 1;
        } else {
            return differenceDays;
        }
    }

    return (
        <Dialog open={isOpen}>
            <DialogHeader>Convert room {roomConvertRequest.currentRoomNo} {roomConvertRequest.roomTypeToChange.toLowerCase()} to</DialogHeader>
            <DialogBody>
                <div className="w-full lg:w-12/12 px-4 rounded overflow-scroll">
                    <div className="relative w-full mb-1">
                        <div className="flex flex-wrap border border-gray-300 p-2" >
                            <div className="w-50 mr-3 mt-3 mb-3">
                                <label htmlFor="currentRoomNo" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Same Room No</label>
                                <select label="currentRoomNo" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-10 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                    name="currentRoomNo" id="currentRoomNo" disabled={true}
                                    onChange={(event) => { }}
                                    value={roomConvertRequest.currentRoomNo}>
                                    <option value={roomConvertRequest.currentRoomNo}>{roomConvertRequest.currentRoomNo}</option>
                                </select>
                            </div>
                            <div className="w-50 mr-3 mt-3 mb-3">
                                <label htmlFor="newRoomType" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">New Category<span className="text-red-500">*</span></label>
                                <select label="newRoomType" color="blue" className="bg-white text-gray-900 border border-gray-300 rounded-md py-2 pl-3 pr-10 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
                                    name="newRoomType" id="newRoomType"
                                    onChange={(event) => setNewRoomType(event.target.value)}
                                    value={newRoomType}>
                                    <option value="">Select</option>
                                    {roomConvertRequest.roomTypes.filter(rt => rt.category.toLowerCase() !== roomConvertRequest.roomTypeToChange.toLowerCase()).map((category, i) => (
                                        <option key={i} value={category.category}>{category.category}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="w-50 mr-3 mt-3 mb-3">
                                <label htmlFor="currentRoomNo" className="block uppercase text-blueGray-600 text-xs font-bold mb-2">Discount per Day</label>
                                <input type="number" id={`unitDiscount`} name={`unitDiscount`}
                                    className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                                    value={unitDiscount} onChange={(e) => setUnitDiscount(parseInt(e.target.value))} />
                            </div>
                        </div>
                    </div>
                    <div className="relative w-full mb-1">
                        <label className="block uppercase text-blueGray-600 text-xs font-bold" >
                            Updated Details
                        </label>
                        <div className="overflow-auto max-h-[500px]">
                            <div className="grid grid-cols-1">
                                {newPaymentDetails.map((priceDetail, i) => (
                                    <Card key={i} className="shadow-lg rounded-2xl border border-gray-200">
                                        <CardBody>
                                            <div className="text-md text-gray-800">Room No: {priceDetail.roomNo}</div>
                                            <div className="text-md font-semibold text-gray-800">Room Type: {priceDetail.category}</div>
                                            <div className="text-md font-semibold text-gray-800">Effective: {priceDetail.effectiveCheckInDate}</div>
                                            <div className="text-md text-gray-800">Room Fare: ₹{priceDetail.fare}.00</div>
                                            <div className="text-md text-gray-800">Extra Bed Cost: ₹{priceDetail.extraBedCost}.00</div>
                                            <div className="text-md text-gray-800">GST (12%): ₹{priceDetail.gst}.00</div>
                                            <div className="text-md text-gray-800">Total Cost: ₹{priceDetail.totalCost}.00</div>
                                            <div className="text-md text-gray-800">Discount: ₹{priceDetail.discount}.00</div>
                                        </CardBody>
                                    </Card>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </DialogBody>
            <DialogFooter>
                <Button
                    variant="text"
                    color="red"
                    onClick={onClose}
                    className="mr-1"
                >
                    <span>Cancel</span>
                </Button>
                <Button variant="gradient" color="green" onClick={handleSubmitInternal}>
                    <span>Save</span>
                </Button>
            </DialogFooter>
        </Dialog>
    );
}
